import { Component, OnInit, ViewEncapsulation, HostListener, ElementRef, ViewChild } from '@angular/core';
import { trigger, state, style, AUTO_STYLE, transition, animate } from '@angular/animations';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ToastsManager } from "ng2-toastr";
import * as moment from 'moment';

import { CompaniesService } from "../../services/companies.service";
import { Company } from '../../models/Company.model';
import { CommonHelper } from '../../shared/helpers/CommonHelper';
import { CompanyGroup } from '../../models/CompanyGroup.model';
import { CompanyGroupSearch } from "../../models/CompanyGroupSearch.model";
import { runInThisContext } from 'vm';

@Component({
    selector: 'self-registration',
    templateUrl: './self-registration.component.html',
    styleUrls: ['./self-registration.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('cardToggle', [
            state('collapsed, void',
                style({
                    overflow: 'hidden',
                    height: '0px',
                })
            ),
            state('expanded',
                style({
                    height: AUTO_STYLE,
                })
            ),
            transition('collapsed <=> expanded', [
                animate('500ms ease-in-out')
            ])
        ]),
        trigger('cardToggleInverse', [
            state('collapsed, void',
                style({
                    overflow: 'hidden',
                    height: '0px',
                })
            ),
            state('expanded',
                style({
                    height: AUTO_STYLE,
                })
            ),
            transition('collapsed <=> expanded', [
                animate('50ms ease-in-out')
            ])
        ])
    ]
})

export class SelfRegistrationComponent implements OnInit {
    @ViewChild("modalcontainer") modalcontainer: ElementRef;
    loading: boolean;
    menuType: string;
    headerType: string;
    sidebarType: string;
    themeType: string;
    toggledArrow: string;
    windowHeight: number;
    windowWidth: number;
    settingToggle: string;
    cardToggle = 'collapsed';

    mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
    cnpjPattern = /^([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2})$/i;
    companyForm: FormGroup;
    company: Company = new Company();
    commonHelper: CommonHelper = new CommonHelper();
    companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
    companyGroupSearchModel: CompanyGroupSearch;
    completedFill: boolean = false;
    expired: Date;
    products;

    constructor(
        private companiesService: CompaniesService,
        private toastr: ToastsManager,
        private router: Router,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
    ) {
        this.themeType = 'default';
        this.toggledArrow = 'icon-arrow-left-circle';
        this.settingToggle = 'off';
        this.windowHeight = window.innerHeight - 60;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 1170) {
            this.menuType = 'mini-sidebar';
        }
        if (this.windowWidth < 768) {
            this.toggledArrow = 'fa fa-bars';
        }
    }

    async ngOnInit() {
        this.loading = true;
        const hash = this.route.snapshot.params["hash"];
        if(!hash){
            this.toastr.warning('Impossível abrir formulário de cadastro. É necessário informar o HASH na URL.');
            this.completedFill = true;
        }

        try {
            this.companyForm = this.formBuilder.group({
                name: [null, Validators.required],
                companyName: [null, Validators.required],
                ownerName: [null, Validators.required],
                subscriber: [null, Validators.required],
                subscriberEmail: [null, [Validators.required, Validators.email]],
                cnpj: [null, [Validators.required, Validators.pattern(this.cnpjPattern)]],
                emails: [null, Validators.required]
            });
            const resp = await this.companiesService.getTemporaryCompany(hash);
            if(!resp){
                this.toastr.warning('Empresa não encontrada, o HASH informado é inválido.');
                return;
            }

            this.completedFill = resp.completedFill;
            this.expired = new Date(resp.expired);
            this.products = resp.products;
            const currentDate = new Date();

            if(this.completedFill){
                this.toastr.warning('Cadastro de empresa já foi finalizado');
            } else if(currentDate > this.expired){
                this.toastr.warning('Operação inválida. Data de cadastro expirou');
                this.completedFill = true;
            } else {
                this.company = resp.company;
                if(this.company.start)
                    this.company.start = moment(this.company.start).format("DDMMYYYY");
                if(this.company.end)
                    this.company.end = moment(this.company.end).format("DDMMYYYY");
            }

        } catch(err){
            console.log(err);
            this.toastr.warning('Link de pré-cadastro não encontrado, o HASH informado na URL é inválido.');
            this.loading = false;
            this.completedFill = true;
        }

        this.loading = false;
    }

    onResize(event) {
        this.windowHeight = event.target.innerHeight - 60;
        this.windowWidth = window.innerWidth;
        if (this.windowWidth < 1170) {
            this.menuType = 'mini-sidebar';
        } else {
            this.menuType = '';
        }

        if (this.windowWidth < 768) {
            this.toggledArrow = this.menuType === 'mini-sidebar show-sidebar' ? 'fa fa-close' : 'fa fa-bars';
        } else {
            this.toggledArrow = this.menuType === 'mini-sidebar' ? 'fa fa-bars' : 'icon-arrow-left-circle';
        }
    }

    async OnSave() {
        if (this.companyForm.valid) {
            const response = await this.companiesService.updateTemporaryCompany(this.company);
            if(response._id){
                this.toastr.success('Autocadastro realizado com sucesso. Você já pode fechar esta página.');
                this.completedFill = true;
            } else {
                this.toastr.warning('Erro ao atualizar empresa. Tente novamente.');
            }
        }
    }

    verifyValidTouched(fieldName) {
        return !this.companyForm.get(fieldName).valid && this.companyForm.get(fieldName).touched;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }

    async cnpjSearch() {
        if (this.company.cnpj == '') {
            this.toastr.warning('CNPJ não pode ser vazio');
        } else {
            this.company.cnpj.trim();
            this.toastr.warning('Realizando consulta ao CNPJ...');
            let response = await this.companiesService.getCnpjTemporaryCompany(this.company.cnpj);
            if (response.status == 'ERROR') {
                this.toastr.warning(response.message);
            } else {
                if (response.fantasia != '') this.company.name = response.fantasia;
                if (response.nome != '') this.company.companyName = response.nome;
                if (response.logradouro != '') this.company.address.street = response.logradouro;
                if (response.numero != '') this.company.address.number = response.numero;
                if (response.complemento != '') this.company.address.complement = response.complemento;
                if (response.municipio != '') this.company.address.city = response.municipio;
                if (response.uf != '') this.company.address.uf = response.uf;
                if (response.bairro != '') this.company.address.district = response.bairro;
                if (response.cep != '') this.company.address.zipCode = response.cep;
                if (response.tipo != '') this.company.address.type = response.tipo;
            }
        }
    }

    openModal(){
        let modal = this.modalcontainer.nativeElement;
        modal.style.display = "block";
    }

    closeModal(){
        let modal = this.modalcontainer.nativeElement;
        modal.style.display = "none";
    }
}



// WEBPACK FOOTER //
// ./src/app/views/self-registration/self-registration.component.ts